import { useState } from 'react';

export interface FaqItem {
  q: string;
  a: string;
}

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="flex flex-col gap-3">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={item.q}
            className={`overflow-hidden rounded-lg border transition-colors ${
              isOpen ? 'border-primary-300 bg-background-100' : 'border-background-200 bg-background-50'
            }`}
          >
            <h3>
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => setOpenIndex(isOpen ? null : index)}
                className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
              >
                <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                    isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                  }`}
                >
                  <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-base`}></i>
                </span>
              </button>
            </h3>
            <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
              <div className="overflow-hidden">
                <p className="px-4 pb-4 font-body text-sm leading-relaxed text-foreground-600 md:px-5">{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}